import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10 6"
        fill="none"
        style={{ overflow: 'visible', ...props.style }}
        {...props}
    >
        <path
            d="M3.14584 4.58579L1.97427 3.41421C0.521219 1.96116 -0.205308 1.23463 0.0503926 0.617317C0.306094 0 1.33356 0 3.38849 0H5.73163C7.78656 0 8.81402 0 9.06973 0.617317C9.32543 1.23463 8.5989 1.96116 7.14585 3.41421L7.14584 3.41422L5.97427 4.58579C5.30761 5.25245 4.97427 5.58579 4.56006 5.58579C4.14585 5.58579 3.81251 5.25245 3.14584 4.58579Z"
            fill="currentColor"
        />
    </svg>
);

export { SvgComponent as TooltipTriangleIcon };
